import { queryOptions } from '@tanstack/react-query';

import { practiceApi } from './practice.api';

// Two keys, not one: a location mutation invalidates `locations()` without refetching the tax ID,
// and a practice-information save invalidates `details()` without refetching the location list.
export const queryKeys = {
    all: ['practice'] as const,
    details: () => [...queryKeys.all, 'details'] as const,
    locations: () => [...queryKeys.all, 'locations'] as const,
};

export function practiceDetailsOptions() {
    return queryOptions({
        queryKey: queryKeys.details(),
        queryFn: ({ signal }) => practiceApi.getDetails(signal),
    });
}

export function practiceLocationsOptions() {
    return queryOptions({
        queryKey: queryKeys.locations(),
        queryFn: ({ signal }) => practiceApi.listLocations(signal),
    });
}
